import { IRootState } from '../../../../store'
import { ITitrateState } from '../store/titrate.types'

export const getTitrateSelector = (state: IRootState): ITitrateState => state.titrate
